import {useContext} from 'react';
import EventDispatcherContext from './EventDispatcherContext';
import {EventDispatcher} from './types';

export default function useEventDispatcher(): EventDispatcher {
  const eventDispatcher = useContext(EventDispatcherContext);

  return eventDispatcher;
}
